import type { ReactNode } from 'react';

import { Button, Tooltip, TooltipContent, TooltipTrigger } from 'design-system';

import getFactsheetLink from '../../lib/getFactsheetLink';
import { useFactsheetOpenState } from '../../state/useFactsheetOpenState';

const FactsheetDialogButtonBase = ({
  code,
  children,
  mode = 'modal',
  ariaLabel,
  tooltip
}: {
  code: string;
  children: ReactNode;
  mode?: 'modal' | 'newTab';
  ariaLabel?: string;
  tooltip?: ReactNode;
}) => {
  const { open } = useFactsheetOpenState();

  const button = (
    <Button
      aria-label={ariaLabel}
      className='h-auto p-0 text-inherit'
      variant='link'
      onClick={e => {
        e.stopPropagation();
        if (mode === 'newTab') {
          window.open(getFactsheetLink(code), '_blank');
          return;
        }
        open(code);
      }}
    >
      {children}
    </Button>
  );

  if (!tooltip) return button;

  return (
    <Tooltip>
      <TooltipTrigger render={button} />
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
};
export default FactsheetDialogButtonBase;
